import { setStoresAction as setStoresOperation } from 'editor/src/store/mockup/slice';

export default setStoresOperation;
